import type { EventCategory, EventType } from '../models/middleware/event-item.model';
import type { OverviewItemModel } from '../models/middleware/overview-item.model';

export const eventCategoryLabels: Record<EventCategory, string> = {
  information: 'Informationen',
  knowledge: 'Wissen',
  socializing: 'Socializing',
  highlight: 'Highlight@4E',
  special: 'Special',
};

export const eventCategoryColors: Record<EventCategory, string> = {
  information: 'blue',
  knowledge: 'green',
  socializing: 'pink',
  highlight: 'purple',
  special: 'red',
};

export function getEventCategoryLabel(eventType: EventType, category?: EventCategory): string {
  if (eventType === 'Other') {
    if (!category) {
      throw new Error(`Subcategory for 'Other' event type not specified`);
    }
    return eventCategoryLabels[category] ?? 'Special';
  }
  return eventCategoryLabels[mapEventTypeToCategory(eventType)];
}

export function mapEventTypeToCategory(category: EventType): EventCategory {
  switch (category) {
    case 'NewsAtFourEnergy':
      return 'information';
    case 'LearningAtLunch':
      return 'knowledge';
    case 'Afterwork':
      return 'socializing';
    case 'Offsite':
    case 'Weihnachtsfeier':
      return 'highlight';
    case 'Other':
      return 'special';
    default:
      throw new Error(`Subcategory for '${category}' event type not specified`);
  }
}

export function getEventCategoryColor(category: EventCategory): string {
  return eventCategoryColors[category];
}

export type EventTypeFilter = 'Alle' | 'Remote' | 'Real Life';

export const EVENT_TYPE_FILTERS: EventTypeFilter[] = ['Alle', 'Remote', 'Real Life'];

export function getEventType(category: EventType, remoteEvent?: boolean): EventTypeFilter {
  const realLifeEvents: EventType[] = ['Offsite', 'Afterwork', 'Weihnachtsfeier'];
  return realLifeEvents.includes(category) || (category === 'Other' && !remoteEvent) ? 'Real Life' : 'Remote';
}

export function filterEventsByType(events: OverviewItemModel[], filter: EventTypeFilter): OverviewItemModel[] {
  if (filter === 'Alle') {
    return events;
  }

  return events.filter((event) => getEventType(event.type, event.remoteEvent) === filter);
}
